
// Imports should be placed on top of the file

// Importing Global CSS file
import "./src/styles/global.css"

